import process from 'process';

const env = process?.env?.REACT_APP_STAGE;
const config = require(`../env/${env}`).default;
export default { ...config, local: env === 'local', env };
